import { render, staticRenderFns } from "./UpgradeFeatureDetail.vue?vue&type=template&id=2d0c67f2&scoped=true"
import script from "./UpgradeFeatureDetail.vue?vue&type=script&lang=js"
export * from "./UpgradeFeatureDetail.vue?vue&type=script&lang=js"
import style0 from "./UpgradeFeatureDetail.vue?vue&type=style&index=0&id=2d0c67f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c67f2",
  null
  
)

export default component.exports